// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3k9nh","footer":"ReportModalFilter_footer__16FWa"};